import { ClaimAvatar } from '@/components/Header/ClaimAvatar'
import { NavigationMenu } from '@/components/Header/NavigationMenu'
import { Zorb } from '@/components/Header/Zorb'
import Link from 'next/link'
import React from 'react'
import { View } from 'reshaped'
import styles from './MetallicBorder.module.css'

export const Header = () => {
  return (
    <View as="header" width="100%" paddingInline={6}>
      <View
        direction="row"
        borderRadius="xlarge"
        justify="space-between"
        align="center"
        className={styles.metallicBorder}
      >
        <View
          direction="row"
          gap={3}
          align="center"
          paddingTop={2.5}
          paddingBottom={2.5}
          paddingInline={6}
          width="100%"
          justify="space-between"
        >
          <View direction="row" gap={3} align="center">
            <Link href={'/'}>
              <View direction="column">
                <Zorb />
              </View>
            </Link>

            <NavigationMenu />
          </View>
          <ClaimAvatar />
        </View>
      </View>
    </View>
  )
}
